module.exports = __webpack_public_path__ + "static/assets/ff4c6769fcc78cd784fd7dc363c29427.svg";